import React from 'react';
import { substanceNotes } from '../tableNotes'

const NO_PROB = 'no problems reported';
const PROB = 'potential of a significant problem';

const SubstanceUseRow = ({ advanceReport }) => {
  const { crafft } = advanceReport.results.child
  
  var crafftScore = "N/A"
  if (crafft && crafft !== "No answer given") {
    const score = parseInt(crafft.charAt(crafft.length - 1))
    crafftScore = `${score}/6, ${score < 2 ? NO_PROB : PROB}`
  }

  const substanceUseChildAnswers = () => {
    const { child } = advanceReport.questions

    return child.map((q) => {
      if (q.question_name !== 'sbirt' || q.answer_text === 'Never') return null

      return (
        <div key={q.question_text} className="flex flex-col pb-2">
          {q.question_text} : {' '}
          <span className="font-normal">
            {q.answer_text}
          </span>
        </div>
      )
    })
  }

  return (
    <div className="table-row border-t-2 border-b-2 border-sw-lightest-gray align-top" role="row">
      <div className="print-symptom table-cell font-bold text-lg text-sw-dark-blue py-3 pr-2" role="rowheader">
        Substance
        <br />
        Use
      </div>
      <div className="table-cell text-xs text-sw-dark-blue font-bold py-3 pr-3 align-top leading-loose" role="gridcell">
        {substanceUseChildAnswers()}
        CRAFFT score = {crafftScore}
      </div>
      <div className="table-cell text-xs text-sw-dark-blue font-bold py-3 pr-3 align-top leading-loose" role="gridcell">
        Not Asked
      </div>
      <div className="summary-notes-col table-cell align-top" role="gridcell">
        {substanceNotes(advanceReport)}
      </div>
    </div>
  )
}

export default SubstanceUseRow